// v-safe-html attribute is safe compared to v-html
import DOMPurify from 'dompurify'

export default {
  install (app) {
    app.directive('safe-html', {
      beforeMount (el, binding) {
        el.innerHTML = DOMPurify.sanitize(binding.value)
      },
      updated (el, binding) {
        el.innerHTML = DOMPurify.sanitize(binding.value)
      },
    })
  },
}
